import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateUser = props => {
  return (
    <Create
// @ts-ignore
      title='Create User'
      fields={fields}
      apiPath='admin/users'
      successRedirectPath={resource => `/security/users/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateUser
